<template>
    <base-modal
        title="Creación de ruta predeterminada"
        size="sm"
        :show-default-footer="false"
    >
        <p>Se ha creado la ruta correctamente.</p>
        
        <template #footer>
            <button 
                type="button" 
                class="btn text-white bg-utel rounded-8" 
                @click="redirectTo"
            >
                Finalizar
            </button>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'ModalConfirmation',
    components: { BaseModal },
    props: {
        url_redirect: { type: String, required: true }
    },
    methods: {
        redirectTo() {
            window.location.href = this.url_redirect;
        }
    }
};
</script>
